import { Injectable, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { Subject } from 'rxjs';
import { AlertWindowComponent } from 'src/app/common/alert-window/alert-window.component';
import { FullSpinnerService } from 'src/app/common/full-spinner/full-spinner.service';
import { BatchStockdetailsComponent } from 'src/app/select-modal/batch-stockdetails/batch-stockdetails.component';
import { RatewiseCurrentstockComponent } from 'src/app/select-modal/ratewise-currentstock/ratewise-currentstock.component';
import { SelectSerialInvoiceComponent } from 'src/app/select-modal/select-serial-invoice/select-serial-invoice.component';
import { SelectserialStockreqNoitemComponent } from 'src/app/select-modal/selectserial-stockreq-noitem/selectserial-stockreq-noitem.component';
import { DataService } from 'src/app/service/data.service';
import { MultigodownSelectionComponent } from 'src/app/select-modal/multigodown-selection/multigodown-selection.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatrixSelectionComponent } from 'src/app/select-modal/matrix-selection/matrix-selection.component';

@Injectable({
  providedIn: 'root'
})
export class TransferStockNewService {
  godowns = [];
  responseData: any;
  loadingTrue = false;
  tableLoading = false;
  btnClicked = false;
  addloadingTrue = false;
  CloadingTrue = false;
  priceUpdate = false;
  scanbarcode = '';
  scanbarcodeid = '';
  barcode = '';
  barcoderefn = '';
  searchItem = {
    type: 'NAME',
    text: ''
  };
  tsData = {
    tempsalesno: '',
    displaysalesno: '',
    branchcode: '',
    finyearcode: '',
    salesdate: '',
    despatchaddress01: '',
    despatchaddress02: '',
    despatchaddress03: '',
    despatchaddress04: '',
    salesnotes: '',
    roundoffamount: '',
    netamount: '',
    createdby: '',
    createddatetime: '',
    approved: '',
    approvedby: '',
    approveddatetime: '',
    approval_timetaken: '',
    approval_timeelapsed: '',
    branchtransfer: 'YES',
    transfertobranchcode: '',
    transfertobranchname: '',
    salesentrytypename: '',
    questioncode: '',
    questionanswer: '',
    items: [],
    available_items: [],
  };
  selectedItem = {
    ic: '',
    refn: '',
    ina: '',
    sr: '',
    srafterdisc: '',
    srorg: '',
    mrp: '',
    currencysrorg: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    srwithtax: '',
    valuewithtax: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sdp: '',
    schemediscvalue: '',
    serialnumbers: [],
    reffield2: [],
    reffield3: [],
    reffield4: [],
    reffield5: [],
    reffield6: [],
    reffield7: [],
    reffield8: [],
    reffield9: [],
    reffield10: [],
    serialgodowncodes: [],
    serialgodownnames: [],
    batchno: '',
    mfgdate: '',
    expdate: '',
    description: '',
    ac: '',
    mrp_profitper: '',
    mrp_profitamt: '',
    sr_profitper: '',
    sr_profitamt: '',
    description2: '',
    description3: '',
    description4: '',
    description5: '',
    cesspercent: '',
    cessamount: '',
    dispname: '',
    extracessrate: '',
    extracessamount: '',
    uom: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    mfrname: '',
    hsncode: '',
    hsnrefno: '',
    matrix1code: '',
    matrix1id: '',
    matrix1name: '',
    matrix2code: '',
    matrix2id: '',
    matrix2name: '',
    matrix3code: '',
    matrix3d: '',
    matrix3name: '',
    matrix4code: '',
    matrix4id: '',
    matrix4name: '',
    matrix5code: '',
    matrix5id: '',
    matrix5name: '',
    matrix6code: '',
    matrix6id: '',
    matrix6name: '',
    matrix7code: '',
    matrix7id: '',
    matrix7name: '',
    matrix8code: '',
    matrix8id: '',
    matrix8name: '',
    matrix9code: '',
    matrix9id: '',
    matrix9name: '',
    matrix10code: '',
    matrix10id: '',
    matrix10name: '',
    reftype: '',
    salespersoncode: '',
    salespersonname: '',
    returnbalqty: '',
    dcbillbalqty: '',
    ssr: '',
    editbeforedetails: {
      srorg: '',
      batchno: '',
      bc: '',
      matrix1code: '',
      matrix2code: '',
      matrix3code: '',
      matrix4code: '',
      matrix5code: '',
      matrix6code: '',
      matrix7code: '',
      matrix8code: '',
      matrix9code: '',
      matrix10code: ''
    },
    godowndetail: []
  };
  itemRestoreData = {
    ic: '',
    refn: '',
    sr: '',
    srorg: '',
    currencysrorg: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    reftype: '',
    cesspercent: '',
    cessamount: '',
    extracessrate: '',
    extracessamount: ''
  };
  itemDetails = {
    serialdetails: {
      reffield2: {
        required: '',
        mandatory: ''
      },
      reffield3: {
        required: '',
        mandatory: ''
      },
      reffield4: {
        required: '',
        mandatory: ''
      },
      reffield5: {
        required: '',
        mandatory: ''
      },
      reffield6: {
        required: '',
        mandatory: ''
      },
      reffield7: {
        required: '',
        mandatory: ''
      },
      reffield8: {
        required: '',
        mandatory: ''
      },
      reffield9: {
        required: '',
        mandatory: ''
      },
      reffield10: {
        required: '',
        mandatory: ''
      },
      reffielddisplaycolumns: []
    },
    matrixsetup: {
      matrix1: {
        required: ''
      },
      matrix2: {
        required: ''
      },
      matrix3: {
        required: ''
      },
      matrix4: {
        required: ''
      },
      matrix5: {
        required: ''
      },
      matrix6: {
        required: ''
      },
      matrix7: {
        required: ''
      },
      matrix8: {
        required: ''
      },
      matrix9: {
        required: ''
      },
      matrix10: {
        required: ''
      },
      matrixheaddisplaycolumns: [],
      matrixnamedisplaycolumns: []
    },
    branchwiseminmaxstocks: [],
    branchwisemrpdiscounts: [],
    branchwisepricing: [],
    branchwiseproducts: [],
    multibarcodes: [],
    quantitypricesetup: {
      qtywisepricing: []
    },
    margindetails: {
      mrpmargindetails: {
        mrpdisc1per: '',
        mrpdisc2per: '',
        mrpmargin: '',
        mrpmarkupper: '',
        mrpmarkdownper: '',
        mrpnetmargin: '',
        mrpnetmarginper: ''
      },
      purchasedetails: {
        prdiscper: '',
        prtaxvalue: '',
        prwithtax: ''
      },
      salesmargindetails: {
        srdiscper: '',
        srwithouttax: '',
        srtaxvalue: '',
        srmargin: '',
        srmarkupper: '',
        srmarkdownper: '',
        srnetmargin: '',
        srnetmarginper: ''
      },
      priceschemes: {
        dlrpdiscper: '',
        dlrpmarginper: '',
        dlrpmarginvalue: '',
        p1discper: '',
        p1marginper: '',
        p1marginvalue: '',
        p2discper: '',
        p2marginper: '',
        p2marginvalue: '',
        p3discper: '',
        p3marginper: '',
        p3marginvalue: '',
        p4discper: '',
        p4marginper: '',
        p4marginvalue: '',
        p5discper: '',
        p5marginper: '',
        p5marginvalue: '',
        p6discper: '',
        p6marginper: '',
        p6marginvalue: ''
      },
      roundoffnetvalues: ''
    },

    ic: '',
    ina: '',
    refn: '',
    sr: '',
    tp: '',
    cc: '',
    dp: '',
    da: '',
    unit: '',
    itemactive: '',
    reftype: '',
    stkchk: '',
    hsncode: '',
    taxcode: '',
    sq: '',
    fd: '',
    uomcode: '',
    subuomcode: '',
    mpchk: '',
    pr: '',
    mrp: '',
    dlrp: '',
    bc: '',
    bcm: '',
    pcm: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: '',
    d1: '',
    d2: '',
    d3: '',
    d4: '',
    d5: '',
    d6: '',
    netwt: '',
    grswt: '',
    imc: '',
    ilc: '',
    origincode: '',
    onlineallowed: '',
    mfgdateyn: '',
    expdays: '',
    cc2: '',
    cc3: '',
    cc4: '',
    cc5: '',
    itemtypecode: '',
    cesspercent: '',
    extracessrate: ''
  };
  defC: any = {
    allcolumns: {
      slno: {
        displayname: ''
      },
      ic: {
        displayname: ''
      },
      refn: {
        displayname: ''
      },
      ina: {
        displayname: ''
      },
      sr: {
        displayname: ''
      },
      srorg: {
        displayname: ''
      },
      currencysrorg: {
        displayname: ''
      },
      value: {
        displayname: ''
      },
      valueorg: {
        displayname: ''
      },
      qty: {
        displayname: ''
      },
      sq: {
        displayname: ''
      },
      fd: {
        displayname: ''
      },
      bc: {
        displayname: ''
      },
      batchno: {
        displayname: ''
      },
      mfgdate: {
        displayname: ''
      },
      expdate: {
        displayname: ''
      },
      description: {
        displayname: ''
      },
      description2: {
        displayname: ''
      },
      description3: {
        displayname: ''
      },
      description4: {
        displayname: ''
      },
      description5: {
        displayname: ''
      },
      dispname: {
        displayname: ''
      },
      uom: {
        displayname: ''
      },
      matrix1id: {
        displayname: ''
      },
      matrix1name: {
        displayname: ''
      },
      matrix2id: {
        displayname: ''
      },
      matrix2name: {
        displayname: ''
      },
      matrix3id: {
        displayname: ''
      },
      matrix3name: {
        displayname: ''
      },
      matrix4id: {
        displayname: ''
      },
      matrix4name: {
        displayname: ''
      },
      matrix5id: {
        displayname: ''
      },
      matrix5name: {
        displayname: ''
      },
      matrix6id: {
        displayname: ''
      },
      matrix6name: {
        displayname: ''
      },
      matrix7id: {
        displayname: ''
      },
      matrix7name: {
        displayname: ''
      },
      matrix8id: {
        displayname: ''
      },
      matrix8name: {
        displayname: ''
      },
      matrix9id: {
        displayname: ''
      },
      matrix9name: {
        displayname: ''
      },
      matrix10id: {
        displayname: ''
      },
      matrix10name: {
        displayname: ''
      }
    },
    displaycolumns: []
  };
  displayColumn: any = [];
  matrixsetup = {
    matrix1: {
      required: '',
      caption: ''
    },
    matrix2: {
      required: '',
      caption: ''
    },
    matrix3: {
      required: '',
      caption: ''
    },
    matrix4: {
      required: '',
      caption: ''
    },
    matrix5: {
      required: '',
      caption: ''
    },
    matrix6: {
      required: '',
      caption: ''
    },
    matrix7: {
      required: '',
      caption: ''
    },
    matrix8: {
      required: '',
      caption: ''
    },
    matrix9: {
      required: '',
      caption: ''
    },
    matrix10: {
      required: '',
      caption: ''
    },
  };
  xrate = '';
  xdisc = '';
  xqty = '';
  batchstocks = '';
  constructSerials = [];
  getDataObservable: Subject<any> = new Subject();
  datasource: any = new MatTableDataSource();
  @ViewChild('ic', { static: false }) ic;
  constructor(
    public storage: Storage,
    public data: DataService,
    public dialog: MatDialog,
    public router: Router,
    public fullspinner: FullSpinnerService
  ) { }

  checkForPending() {
    this.storage.get('tsData').then((val) => {
      if (val) {
        this.draftItemRestore(val);
      } else {
        setTimeout(() => {
          this.clearAllTempData();
        }, 400);
        this.getTransferStockDefaultData();
      }
    });
  }


  getDefaultValue() {
    if (this.data.token !== '') {
      if (this.data.authorizationResponse.edition_features.batch_stocks_management === "YES" && this.data.authorizationResponse.softwaresetup.data.batchconceptsyn === 'YES') {
        this.displayColumn = ['slno', 'refn', 'ina', 'batchno', 'expdate', 'qty', 'srorg', 'value', 'remove'];
      } else {
        this.displayColumn = ['slno', 'refn', 'ina', 'qty', 'srorg', 'value', 'remove'];
      }
      this.tableLoading = true;
      this.data.getData('screencolumn/transferstock').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.defC = this.responseData.data;
          this.defC.displaycolumns.push('remove');
          this.displayColumn = JSON.parse(JSON.stringify(this.defC.displaycolumns));
        }
        this.tableLoading = false;
      }, (error) => {
        this.tableLoading = false;
      });
    } else {
      setTimeout(() => {
        this.getDefaultValue();
      }, 400);
    }
  }

  draftItemRestore(el): void {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: 'Do you want to restore the draft Transfer Stock '
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getTempData(el.tempsalesno);
      } else {
        this.clearAllTempData();
        setTimeout(() => {
          this.getTransferStockDefaultData();
        }, 400);
      }
    });
  }

  getTransferStockDefaultData() {
    this.loadingTrue = true;
    const obj = {
      "entryno": '0',
      "entryfinyearcode": '',
      "entrybranchcode": '',
      "salesentrytypename": "BT_SALES"
    }
    this.data.postData('sales/detail', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.tsData = this.responseData.data;
        this.datasource = new MatTableDataSource(this.responseData.data.available_items);
        this.loadingTrue = false;
        this.tsData.tempsalesno = '';
      } else {
        this.clearAll();
        this.clearAllTempData();
      }
    }, (error) => {
      this.loadingTrue = false;
    });
  }

  clearAll() {
    this.loadingTrue = false;
    this.clearSelectedItem();
    this.clearItemDetails();
    this.clearItemRestoreDetails();
    this.cleartsData();
    this.getTransferStockDefaultData();
  }

  clearSelectedItem() {
    this.selectedItem = {
      ic: '',
      refn: '',
      ina: '',
      sr: '',
      srafterdisc: '',
      srorg: '',
      mrp: '',
      currencysrorg: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      srwithtax: '',
      valuewithtax: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sdp: '',
      schemediscvalue: '',
      serialnumbers: [],
      reffield2: [],
      reffield3: [],
      reffield4: [],
      reffield5: [],
      reffield6: [],
      reffield7: [],
      reffield8: [],
      reffield9: [],
      reffield10: [],
      serialgodowncodes: [],
      serialgodownnames: [],
      batchno: '',
      mfgdate: '',
      expdate: '',
      description: '',
      ac: '',
      mrp_profitper: '',
      mrp_profitamt: '',
      sr_profitper: '',
      sr_profitamt: '',
      description2: '',
      description3: '',
      description4: '',
      description5: '',
      cesspercent: '',
      cessamount: '',
      dispname: '',
      extracessrate: '',
      extracessamount: '',
      uom: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      mfrname: '',
      hsncode: '',
      hsnrefno: '',
      matrix1code: '',
      matrix1id: '',
      matrix1name: '',
      matrix2code: '',
      matrix2id: '',
      matrix2name: '',
      matrix3code: '',
      matrix3d: '',
      matrix3name: '',
      matrix4code: '',
      matrix4id: '',
      matrix4name: '',
      matrix5code: '',
      matrix5id: '',
      matrix5name: '',
      matrix6code: '',
      matrix6id: '',
      matrix6name: '',
      matrix7code: '',
      matrix7id: '',
      matrix7name: '',
      matrix8code: '',
      matrix8id: '',
      matrix8name: '',
      matrix9code: '',
      matrix9id: '',
      matrix9name: '',
      matrix10code: '',
      matrix10id: '',
      matrix10name: '',
      reftype: '',
      salespersoncode: '',
      salespersonname: '',
      returnbalqty: '',
      dcbillbalqty: '',
      ssr: '',
      editbeforedetails: {
        srorg: '',
        batchno: '',
        bc: '',
        matrix1code: '',
        matrix2code: '',
        matrix3code: '',
        matrix4code: '',
        matrix5code: '',
        matrix6code: '',
        matrix7code: '',
        matrix8code: '',
        matrix9code: '',
        matrix10code: ''
      },
      godowndetail: []
    };
  }

  clearItemDetails() {
    this.itemDetails = {
      serialdetails: {
        reffield2: {
          required: '',
          mandatory: ''
        },
        reffield3: {
          required: '',
          mandatory: ''
        },
        reffield4: {
          required: '',
          mandatory: ''
        },
        reffield5: {
          required: '',
          mandatory: ''
        },
        reffield6: {
          required: '',
          mandatory: ''
        },
        reffield7: {
          required: '',
          mandatory: ''
        },
        reffield8: {
          required: '',
          mandatory: ''
        },
        reffield9: {
          required: '',
          mandatory: ''
        },
        reffield10: {
          required: '',
          mandatory: ''
        },
        reffielddisplaycolumns: []
      },
      matrixsetup: {
        matrix1: {
          required: ''
        },
        matrix2: {
          required: ''
        },
        matrix3: {
          required: ''
        },
        matrix4: {
          required: ''
        },
        matrix5: {
          required: ''
        },
        matrix6: {
          required: ''
        },
        matrix7: {
          required: ''
        },
        matrix8: {
          required: ''
        },
        matrix9: {
          required: ''
        },
        matrix10: {
          required: ''
        },
        matrixheaddisplaycolumns: [],
        matrixnamedisplaycolumns: []
      },
      branchwiseminmaxstocks: [],
      branchwisemrpdiscounts: [],
      branchwisepricing: [],
      branchwiseproducts: [],
      multibarcodes: [],
      quantitypricesetup: {
        qtywisepricing: []
      },
      margindetails: {
        mrpmargindetails: {
          mrpdisc1per: '',
          mrpdisc2per: '',
          mrpmargin: '',
          mrpmarkupper: '',
          mrpmarkdownper: '',
          mrpnetmargin: '',
          mrpnetmarginper: ''
        },
        purchasedetails: {
          prdiscper: '',
          prtaxvalue: '',
          prwithtax: ''
        },
        salesmargindetails: {
          srdiscper: '',
          srwithouttax: '',
          srtaxvalue: '',
          srmargin: '',
          srmarkupper: '',
          srmarkdownper: '',
          srnetmargin: '',
          srnetmarginper: ''
        },
        priceschemes: {
          dlrpdiscper: '',
          dlrpmarginper: '',
          dlrpmarginvalue: '',
          p1discper: '',
          p1marginper: '',
          p1marginvalue: '',
          p2discper: '',
          p2marginper: '',
          p2marginvalue: '',
          p3discper: '',
          p3marginper: '',
          p3marginvalue: '',
          p4discper: '',
          p4marginper: '',
          p4marginvalue: '',
          p5discper: '',
          p5marginper: '',
          p5marginvalue: '',
          p6discper: '',
          p6marginper: '',
          p6marginvalue: ''
        },
        roundoffnetvalues: ''
      },

      ic: '',
      ina: '',
      refn: '',
      sr: '',
      tp: '',
      cc: '',
      dp: '',
      da: '',
      unit: '',
      itemactive: '',
      reftype: '',
      stkchk: '',
      hsncode: '',
      taxcode: '',
      sq: '',
      fd: '',
      uomcode: '',
      subuomcode: '',
      mpchk: '',
      pr: '',
      mrp: '',
      dlrp: '',
      bc: '',
      bcm: '',
      pcm: '',
      p1: '',
      p2: '',
      p3: '',
      p4: '',
      p5: '',
      p6: '',
      d1: '',
      d2: '',
      d3: '',
      d4: '',
      d5: '',
      d6: '',
      netwt: '',
      grswt: '',
      imc: '',
      ilc: '',
      origincode: '',
      onlineallowed: '',
      mfgdateyn: '',
      expdays: '',
      cc2: '',
      cc3: '',
      cc4: '',
      cc5: '',
      itemtypecode: '',
      cesspercent: '',
      extracessrate: ''
    };
  }

  clearItemRestoreDetails() {
    this.itemRestoreData = {
      ic: '',
      refn: '',
      sr: '',
      srorg: '',
      currencysrorg: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      reftype: '',
      cesspercent: '',
      cessamount: '',
      extracessrate: '',
      extracessamount: ''
    };
  }

  cleartsData() {
    this.tsData = {
      tempsalesno: '',
      displaysalesno: '',
      branchcode: '',
      finyearcode: '',
      salesdate: '',
      despatchaddress01: '',
      despatchaddress02: '',
      despatchaddress03: '',
      despatchaddress04: '',
      salesnotes: '',
      roundoffamount: '',
      netamount: '',
      createdby: '',
      createddatetime: '',
      approved: '',
      approvedby: '',
      approveddatetime: '',
      approval_timetaken: '',
      approval_timeelapsed: '',
      branchtransfer: 'YES',
      transfertobranchcode: '',
      transfertobranchname: '',
      salesentrytypename: '',
      questioncode: '',
      questionanswer: '',
      items: [],
      available_items: [],
    };
    this.storage.remove('tsData');
  }

  clearAllTempData() {
    this.data.deleteData('draftstocks/clear').then((success) => {
    }, (error) => { });
  }

  getTempData(tempid) {
    this.addloadingTrue = true;
    this.data.getData('sales/' + tempid + '/detail').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.tsData = this.responseData.data;
        this.datasource = new MatTableDataSource(this.responseData.data.available_items);
        this.addloadingTrue = false;
        this.storage.set('tsData', this.tsData);
      } else {
        this.clearAll();
        this.clearAllTempData();
      }
    }, (error) => {
      this.addloadingTrue = false;
    });
  }

  // Get the Item Details and Item Restore Data;
  getData(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        if (restore) {
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
        } else {
          this.CloadingTrue = false;
          this.callPopupfn();
        }
      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.loadingTrue = false;
    });
  }

  // Getting Item Restore Data
  getItemRestoreData(val, xic, xbc) {
    this.fullspinner.spin.next(true);
    if (this.barcode === 'BARCODE') {
      xbc = this.ic.barcoderefn;
    }
    const obj = {
      // branchtransfer: 'YES',
      transfertobranchcode: this.tsData.transfertobranchcode,
      tempsalesno: this.tsData.tempsalesno,
      salesentrytypename: 'BT_SALES',
      items: [
        {
          ic: xic,
          bc: xbc
        }
      ]
    };
    this.data.postData('sales/itemrestore', obj).then((success) => {
      this.responseData = success;
      this.fullspinner.spin.next(false);
      if (this.responseData.Status === true) {
        this.itemRestoreData = this.responseData.data;
        this.selectedItem.qty = this.itemRestoreData.qty;
        setTimeout(() => {
          this.callPopupfn();
          // tslint:disable-next-line: prefer-const
          let data = {};
          const setData = Object.assign(data, this.itemRestoreData);
          this.setItemRestoreDetails(data);
          if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
            this.doConstructSerial();
          }
        }, 100);
        this.loadingTrue = false;
      } else {
        this.data.openAlert(this.responseData);
        this.clearItemRestoreDetails();
        this.loadingTrue = false;
      }
    }, (error) => {
      this.loadingTrue = false;
    });
  }

  // set Item Resore Data with Selected Item
  setItemRestoreDetails(icrd) {
    this.clearSelectedItem();
    this.selectedItem.ina = this.itemDetails.ina;
    this.selectedItem.hsncode = this.itemDetails.hsncode;
    for (const key in this.selectedItem) {
      if (icrd[key]) {
        if (this.selectedItem[key] === icrd[key]) {
          continue;
        } else {
          this.selectedItem[key] = icrd[key];
        }
      }
    }
  }

  callPopupfn() {
    if (this.itemDetails.reftype === 'BATCH') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.getBatchStockDetails();
      }
    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'YES') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.viewRatewiseStock();
      }
    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);
    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();
    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'NO') {
      this.selectGodown();
    } else if (this.itemDetails.reftype === 'MATRIX') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto' || (this.barcode === 'BARCODE' && this.itemDetails.bcm === 'Auto')) {
        this.selectGodown();
      } else {
        this.getMatrix();
      }
    }
  }

  getMatrix(): void {
    const dialogRef = this.dialog.open(MatrixSelectionComponent, {
      width: '900px',
      data: {
        ic: this.selectedItem.ic,
        ina: this.selectedItem.ina,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        matrixsetup: this.itemDetails.matrixsetup
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.matrix1code = result.selectedbill.matrix1code;
        this.selectedItem.matrix2code = result.selectedbill.matrix2code;
        this.selectedItem.matrix3code = result.selectedbill.matrix3code;
        this.selectedItem.matrix4code = result.selectedbill.matrix4code;
        this.selectedItem.matrix5code = result.selectedbill.matrix5code;
        this.selectedItem.matrix6code = result.selectedbill.matrix6code;
        this.selectedItem.matrix7code = result.selectedbill.matrix7code;
        this.selectedItem.matrix8code = result.selectedbill.matrix8code;
        this.selectedItem.matrix9code = result.selectedbill.matrix9code;
        this.selectedItem.matrix10code = result.selectedbill.matrix10code;
        this.viewRatewiseStock();
      }
    });
  }

  doSubmit() {
    if (this.tsData.tempsalesno !== '') {
      this.btnClicked = true;
      this.tsData.salesentrytypename = 'BT_SALES';
      this.data.postData('sales/confirm', this.tsData).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.clearAll();
          this.data.openAlert(this.responseData);
          this.btnClicked = false;
          const routeId = this.responseData.orderno;
          // this.router.navigateByUrl('/home/items/requeststock-details/' + routeId);
        } else {
          if (this.responseData.questioncode) {
            if (parseFloat(this.responseData.questioncode) > 0) {
              this.doAskQuestion(this.responseData);
            } else {
              this.data.openAlert(this.responseData);
              this.btnClicked = false;
            }
          } else {
            this.data.openAlert(this.responseData);
            this.btnClicked = false;
          }
        }
      }, (error) => {

      });
    }
  }

  doAskQuestion(val) {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: val.Message,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.tsData.questioncode = val.questioncode;
        this.tsData.questionanswer = 'YES';
        this.doSubmit();
      } else if (!result) {
        this.btnClicked = false;
      }
    });
  }

  getSingleData(tempid) {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      this.data.getData('sales/' + tempid + '/detail').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.loadingTrue = false;
          this.tsData = this.responseData.data;
          this.datasource = new MatTableDataSource(this.responseData.data.available_items);
        } else {
          this.clearAll();
          this.clearAllTempData();
        }
        this.loadingTrue = false;
      }, (error) => {

      });
    } else {
      setTimeout(() => {
        this.getSingleData(tempid);
      }, 400);
    }
  }

  updateRate() {
    if (parseFloat(this.selectedItem.qty) > 0) {
      this.fullspinner.spin.next(true);
      this.priceUpdate = true;
      this.tsData.salesentrytypename = 'BT_SALES';
      const salesData = JSON.parse(JSON.stringify(this.tsData));
      salesData.items = [];
      salesData.items.push(this.selectedItem);
      this.data.postData('sales/calculate/itemvalues', salesData).then((success) => {
        this.responseData = success;
        this.fullspinner.spin.next(false);
        if (this.responseData.Status === true) {
          const xydata = JSON.parse(JSON.stringify(this.selectedItem));
          this.xrate = xydata.srorg;
          this.xdisc = xydata.dp;
          this.xqty = xydata.qty;
          this.priceUpdate = false;
          this.updateJson(this.responseData.data);
        } else {
          this.priceUpdate = false;
          this.data.openAlert(this.responseData);
        }
      }, (error) => {

      });
    }
  }

  updateJson(newvalue) {
    for (const key in this.selectedItem) {
      if (newvalue[key]) {
        if (this.selectedItem[key] === newvalue[key]) {
          continue;
        } else {
          this.selectedItem[key] = newvalue[key];
        }
      }
    }
  }

  getBatchStockDetails(): void {
    const dialogRef = this.dialog.open(BatchStockdetailsComponent, {
      width: '700px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        entryname: 'BT_SALES',
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.batchno = result.selectedbill.batchno;
        this.selectedItem.srorg = result.selectedbill.salerate;
        this.batchstocks = result.selectedbill.stock;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.batchno === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;
        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  viewRatewiseStock(): void {
    const dialogRef = this.dialog.open(RatewiseCurrentstockComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        reftype: this.itemDetails.reftype,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.ssr = result.selectedbill.sr;
        this.selectedItem.srorg = result.selectedbill.sr;
        this.batchstocks = result.selectedbill.qty;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.sr === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;
        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  selectGodown(): void {
    if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
      const dialogRef = this.dialog.open(MultigodownSelectionComponent, {
        width: '700px',
        data: {
          ic: this.selectedItem.ic,
          ina: this.selectedItem.ina,
          qty: this.selectedItem.qty,
          godowndetail: this.selectedItem.godowndetail,
          entryname: '',
          scanbarcode: this.scanbarcode,
          sbc: this.scanbarcodeid,
          barcode: this.barcode,
          bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.selectedItem.godowndetail = result.godowndetail;
          this.selectedItem.qty = result.qty;
          this.updateRate();
        }
      });
    }
  }

  getSerialItem(val): void {
    console.log(this.selectedItem);
    const dialogRef = this.dialog.open(SelectSerialInvoiceComponent, {
      width: '600px',
      data: {
        ic: this.selectedItem.ic,
        serialnumbers: this.selectedItem.serialnumbers,
        ina: this.selectedItem.ina,
        qty: this.selectedItem.qty
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.selectedserial;
        // this.selectedItem.reffield2 = result.reffield2;
        this.selectedItem.qty = result.selectedserial.length;
        this.selectedItem.srorg = result.salerate;
        this.selectedItem.serialgodowncodes = result.selectedserialgodowncodes;
        this.updateRate();
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  getStockReqNoItem(): void {
    const dialogRef = this.dialog.open(SelectserialStockreqNoitemComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        constructSerials: this.constructSerials,
        ina: this.selectedItem.ina,
        qty: this.selectedItem.qty
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.itemData.serialstocks.serialnumbers;
        this.selectedItem.reffield2 = result.itemData.serialstocks.reffield2;
        this.selectedItem.reffield3 = result.itemData.serialstocks.reffield3;
        this.selectedItem.reffield4 = result.itemData.serialstocks.reffield4;
        this.selectedItem.reffield5 = result.itemData.serialstocks.reffield5;
        this.selectedItem.reffield6 = result.itemData.serialstocks.reffield6;
        this.selectedItem.reffield7 = result.itemData.serialstocks.reffield7;
        this.selectedItem.reffield8 = result.itemData.serialstocks.reffield8;
        this.selectedItem.reffield9 = result.itemData.serialstocks.reffield9;
        this.selectedItem.reffield10 = result.itemData.serialstocks.reffield10;
        this.selectedItem.qty = result.construct.length;
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  exractSerial() {
    return new Promise((res, rej) => {
      let yesConstruct = false;
      if (this.itemDetails.reftype === 'SERIAL') {
        this.selectedItem.serialnumbers = [];
        this.selectedItem.serialgodowncodes = [];
        this.selectedItem.reffield2 = [];
        this.selectedItem.reffield3 = [];
        this.selectedItem.reffield4 = [];
        this.selectedItem.reffield5 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield7 = [];
        this.selectedItem.reffield8 = [];
        this.selectedItem.reffield9 = [];
        this.selectedItem.reffield10 = [];
        this.constructSerials.forEach(element => {
          this.selectedItem.serialnumbers.push(element.serialnumbers);
          this.selectedItem.reffield2.push(element.reffield2);
          this.selectedItem.reffield3.push(element.reffield3);
          this.selectedItem.reffield4.push(element.reffield4);
          this.selectedItem.reffield5.push(element.reffield5);
          this.selectedItem.reffield6.push(element.reffield6);
          this.selectedItem.reffield7.push(element.reffield7);
          this.selectedItem.reffield8.push(element.reffield8);
          this.selectedItem.reffield9.push(element.reffield9);
          this.selectedItem.reffield10.push(element.reffield10);
        });
        yesConstruct = true;
      }
      res(yesConstruct);
    });
  }

  doConstructSerial() {
    // First Check the length of constructSerials
    const xlength = this.constructSerials.length;
    let obj = {
      serialnumbers: '',
      serialgodowncodes: {
        godowncode: '',
        godownname: ''
      },
      reffield2: '',
      reffield3: '',
      reffield4: '',
      reffield5: '',
      reffield6: '',
      reffield7: '',
      reffield8: '',
      reffield9: '',
      reffield10: ''
    };
    if (xlength < 1) {
      for (let i = 0; i < parseFloat(this.selectedItem.qty); i++) {
        obj = {
          serialnumbers: this.selectedItem.serialnumbers[i] ? this.selectedItem.serialnumbers[i] : '',
          serialgodowncodes: {
            godowncode: this.selectedItem.serialgodowncodes[i] ? this.selectedItem.serialgodowncodes[i] : '',
            godownname: this.selectedItem.serialgodownnames[i] ? this.selectedItem.serialgodownnames[i] : ''
          },
          reffield2: this.selectedItem.reffield2[i] ? this.selectedItem.reffield2[i] : '',
          reffield3: this.selectedItem.reffield3[i] ? this.selectedItem.reffield3[i] : '',
          reffield4: this.selectedItem.reffield4[i] ? this.selectedItem.reffield4[i] : '',
          reffield5: this.selectedItem.reffield5[i] ? this.selectedItem.reffield5[i] : '',
          reffield6: this.selectedItem.reffield6[i] ? this.selectedItem.reffield6[i] : '',
          reffield7: this.selectedItem.reffield7[i] ? this.selectedItem.reffield7[i] : '',
          reffield8: this.selectedItem.reffield8[i] ? this.selectedItem.reffield8[i] : '',
          reffield9: this.selectedItem.reffield9[i] ? this.selectedItem.reffield9[i] : '',
          reffield10: this.selectedItem.reffield10[i] ? this.selectedItem.reffield10[i] : ''
        };
        this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
      }
    } else {
      // compare the length with the qty;
      const xqty = parseFloat(this.selectedItem.qty);
      const diff = xqty - xlength;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
        }
      } else if (diff < 0) {
        const xnum = diff * -1;
      }
    }
  }

  getDataEdit(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        if (restore) {
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
        } else {
          this.CloadingTrue = false;
          this.callPopupfnEdit();
        }

      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.CloadingTrue = false;
    });
  }

  callPopupfnEdit() {
    if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);

    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();

    }
  }
}
